export default "__VITE_ASSET__26af56f7__"